var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-40",class:{ 'disabled' : _vm.disabled }},[_c('a-spin',{attrs:{"spinning":_vm.loading !== false,"size":"large"}},[_c('CalendarActions'),_c('CalendarUpload')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }